export const SET_ARTICLES_LIST = 'articles/SET_ARTICLES_LIST'
export const SET_ARTICLE_THEMES_LIST = 'articles/SET_ARTICLE_THEMES_LIST'
